import React from "react";
import classNames from "classnames";

import "./InfoModal.scss";
import { getString } from "./strings";
import { Language } from "../core";

interface InfoModalProps {
  language: Language;
  isOpen: boolean;
  onClose: () => void;
}
export const InfoModal: React.FC<InfoModalProps> = React.memo(
  ({ language, isOpen, onClose }) => {
    return (
      <div className={classNames("infoModal", { isOpen })}>
        <div className="infoModal--inner">
          <p
            dangerouslySetInnerHTML={{
              __html: getString(language, "introDescription")
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: getString(language, "appDescription")
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: getString(language, "eventDescription")
            }}
          />
          <button onClick={onClose}>
            {getString(language, "closeInfoModal")}
          </button>
        </div>
      </div>
    );
  }
);
